export const WEEKLY = 'WEEKLY';
export const FORTNIGHTLY = 'FORTNIGHTLY';
export const MONTHLY = 'MONTHLY';
export const TWO_MONTHLY = 'TWO_MONTHLY';
export const NEVER = 'NEVER';

export const DEFAULT_FREQUENCY = WEEKLY;

export const frequencyOptions = [
  { label: 'Weekly', value: WEEKLY },
  { label: 'Fortnightly', value: FORTNIGHTLY },
  { label: 'Monthly', value: MONTHLY },
  { label: 'Two Monthly', value: TWO_MONTHLY },
];

export const forceChooseFrequencyOptions = [
  { label: 'Choose', value: NEVER },
  ...frequencyOptions,
];

export const forceChooseSubscribedFrequencyOptions = [
  { label: 'Never', value: NEVER },
  ...frequencyOptions,
];
